import request from '@/utils/request';
import { useFd } from '@/utils/formData';
/**
 * AEW Slider API
 */

export function GetSlidersByGroupID(project_id, group_id) {
  const data = useFd('AEW/Client/SliderList', { project_id, group_id })
  return request({ method: 'post', data })
}



// WEBPACK FOOTER //
// ./src/api/client/Slider.js